import React, { useState } from 'react';
import { PopupContainer, PopupContent, PopupHeader, CloseButton, Title, TitleIcon, Message, ButtonContainer, ActionButton } from './style';
import { CheckIcon, RedCrossIcon } from '../ReportIssuePopup/icons';
import ReportIssuePopup from '../ReportIssuePopup';

const ReportIssuePopupResult = ({ onClose, isSuccess }) => {
  const [showReportForm, setShowReportForm] = useState(false);

  const handleAction = () => {
    setShowReportForm(true);
  };

  const handleCloseReportForm = () => {
    setShowReportForm(false);
    onClose();
  };

  if (showReportForm) {
    return <ReportIssuePopup onClose={handleCloseReportForm} />;
  }

  const IconComponent = isSuccess ? CheckIcon : RedCrossIcon;
  const title = isSuccess ? 'Report Sent' : 'Failed to send report';
  const message = isSuccess 
    ? 'Thank you for bringing this to our attention. Our team will attempt to resolve the issue as soon as possible. Please let us know if you have experienced any other issues by clicking below.'
    : 'There was an error while submitting your report. It might just be an internet thing.';
  const buttonText = isSuccess ? 'Report another issue' : 'Try again';

  return (
    <PopupContainer>
      <PopupContent>
        <PopupHeader>
          <Title>
            <TitleIcon>
              <IconComponent />
            </TitleIcon>
            {title}
          </Title>
          <CloseButton onClick={onClose}>×</CloseButton>
        </PopupHeader>
        
        <Message>
          {message}
        </Message>
        
        <ButtonContainer>
          <ActionButton onClick={handleAction}>
            {buttonText}
          </ActionButton>
        </ButtonContainer>
      </PopupContent>
    </PopupContainer>
  );
};

export default ReportIssuePopupResult;
